import { render } from "./ViewGuardados.vue?vue&type=template&id=0599f229&scoped=true"
import script from "./ViewGuardados.vue?vue&type=script&lang=js"
export * from "./ViewGuardados.vue?vue&type=script&lang=js"

import "./ViewGuardados.vue?vue&type=style&index=0&id=0599f229&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0599f229"

export default script